export const routes = {
  root: "/",
  admin: "admin",
  login: "login",
  changePassword: "change-password",
  forgotPassword: "forgot-password",
  resetPasswordOtp: "reset-password-otp",
  latestNews: "latest-news",
  strategicInvestment: "strategic-investment",
  newsMedia: "news-media",
  financialReporting: "financial-reporting",
  annualReporting: "annual-reporting",
  investorInfoMBAPL : "investorInfo-MBAPL",
  investorInfoKPL : "investorInfo-KPL",
  jobPosting: "job-posting",
  action: ":action",
  id: ":id",
};
